// eslint-disable-next-line import/prefer-default-export
export const splitNames = (name) => {
  return {
    firstName: name.split(' ').slice(0, -1).join(' ') || '',
    lastName: name.split(' ').slice(-1).join(' ') || ''
  };
};
